import {
  Alert,
  Button,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PaymentMethod.css";
import cashOnPic from "../../../images/Cash on.png";

const PaymentMethod = (props) => {
  const navigate = useNavigate();
  const {
    gatewayCharge,
    handleGatewayCharge,
    service_refer,
    grandTotal,
    activeTab,
    handleActiveTab,
  } = props;
  console.log("grandTotal:", grandTotal);
  // const [activeTab, setActiveTab] = useState("");
  const [paymentType, setPaymentType] = useState(0);
  const [paymentApi, setPaymentApi] = useState("");
  const [open, setOpen] = useState(false);
  const [alert, setAlert] = useState(0);
  const [payAmount, setPayAmount] = useState(0);
  const [organization, setOrganization] = useState("ghorami");
  const [orderId, setOrderId] = useState("");

  useEffect(() => {
    let x = Math.floor(Math.random() * 1000 + 1);
    let orderId = x + service_refer;
    setOrderId(orderId);
    setPayAmount(grandTotal);
  }, [service_refer, grandTotal]);

  const handlePay = () => {
    const formData = new FormData();
    formData.append("pamount", "105");
    formData.append("organization", "ghoir");
    formData.append("order_id", "sd1254");
    console.log("orderId:", orderId);
    console.log("organization:", organization);
    console.log("payAmount:", payAmount);

    fetch("https://yeapbe.com/test/nagad/index.php", {
      method: "POST",
      body: formData,
    }).then((res) => console.log(res.json()));
  };

  const handleOpen = () => {
    setOpen(true);
    if (!activeTab) {
      setAlert(1);
    } else {
      setAlert(0);
      // navigate("/nagad");
    }
  };
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ marginTop: "20px" }}>
      <Typography variant="p" sx={{ fontSize: "14pt", fontWeight: 700 }}>
        Payment Method
      </Typography>
      <Paper sx={{ marginTop: "20px" }} elevation={5}>
        {alert === 1 && (
          <Alert
            severity="warning"
            onClose={() => {
              setAlert(0);
            }}
            sx={{ marginBottom: "5px", marginTop: "-6%" }}
          >
            Must choose a payment method
          </Alert>
        )}
        <Grid
          container
          rowSpacing={0}
          columnSpacing={0}
          sx={{ paddingTop: "0px" }}
        >
          <Grid item xs={4}>
            <Stack spacing={2} justifyContent="center" alignItems="flex-start">
              <Stack sx={{ paddingTop: "15px", width: "100%" }}>
                <Stack
                  spacing={1}
                  justifyContent="center"
                  alignItems={"center"}
                  className="listContainer"
                >
                  <Button
                    sx={{
                      width: "100%",
                      fontSize: "11pt",
                      fontWeight: 600,
                      color: "black",
                      textTransform: "capitalize",
                      "&:hover": {
                        backgroundColor: "#E0E8BF",
                      },
                    }}
                    className={paymentType === 0 ? "selected" : ""}
                    size="small"
                    onClick={() => {
                      setPaymentType(0);
                    }}
                  >
                    Mobile Wallet
                  </Button>

                  <Button
                    sx={{
                      width: "100%",
                      fontSize: "11pt",
                      fontWeight: 600,
                      color: "black",
                      textTransform: "capitalize",
                      "&:hover": {
                        backgroundColor: "#E0E8BF",
                      },
                    }}
                    size="small"
                    className={paymentType === 3 ? "selected" : ""}
                    onClick={() => {
                      setPaymentType(3);
                    }}
                  >
                    Cash on
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={8}>
            <Box>
              {paymentType === 0 && (
                <Paper
                  sx={{
                    backgroundColor: "#E0E8BF",
                    height: "20%",
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      width: "100%",
                      height: "25vh",
                      backgroundColor: "#E0E8BF",
                      "&:hover": {},
                    }}
                    justifyContent="center"
                    alignItems="center"
                  >
                    {gatewayCharge.map((element) => (
                      <Box
                        sx={{
                          width: "30%",
                          "&:hover": {
                            transform: "TranslateY(-5px)",
                            transition: "all .5s",
                          },
                        }}
                        className={
                          activeTab === element.type
                            ? "selectedPaymentGateway"
                            : ""
                        }
                      >
                        <Box
                          component="img"
                          sx={{
                            width: "100%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleActiveTab(element.type);
                            setPaymentApi(element.api);
                            handleGatewayCharge(element.charge, element.type);
                          }}
                          alt="The house from the offer."
                          src={element.pic}
                        />
                      </Box>
                    ))}
                  </Stack>
                </Paper>
              )}

              {paymentType === 3 && (
                <Stack
                  direction="row"
                  spacing={0}
                  sx={{
                    width: { xs: "100%", md: "100%" },
                    height: "25vh",
                    backgroundColor: "#E0E8BF",
                  }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box
                    sx={{
                      width: "30%",
                      "&:hover": {
                        transform: "TranslateY(-5px)",
                        transition: "all .5s",
                      },
                    }}
                    className={
                      activeTab === "cashOn" ? "selectedPaymentGateway" : ""
                    }
                  >
                    <Box
                      component="img"
                      sx={{
                        width: "100%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleActiveTab("cashOn");
                        // setPaymentApi(element.api);
                        // handleGatewayCharge(element.charge, element.type);
                      }}
                      alt="The house from the offer."
                      src={cashOnPic}
                    />
                  </Box>
                </Stack>
              )}
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default PaymentMethod;
